export const formatAddress = (address) => {
    if (!address) return;

    const firstFourChars = address.substr(0, 6);
    const lastFourChars = address.substr(-4);
    const styledAddress = `${firstFourChars}...${lastFourChars}`;

    return styledAddress;
}